module.exports = __webpack_public_path__ + "static/media/20201216_184618_204_IMG_3135.5c44e3cd.jpg";